import { API } from "aws-amplify";
import moment from "moment";
import { toast } from "react-toastify";
import { getMonths } from "./utils";
import { calcularEdad } from "./productos";
import { getAllDocumentTypes, VALOR_OPORTUNIDAD } from './constants';
export const validatorDate = (value, setValue) => {
  // if (value.length === 0) return "*Revisa los datos ingresados.";
  let date = value;
  if (!moment(date, "YYYY-MM-DD", true).isValid()) {
    if (moment(date, "DD/MM/YYYY", true).isValid()) {
      date = moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
    } else {
      return "Ingrese una fecha de nacimiento válida";
    }
  }

  let dateNow = moment().format("YYYY-MM-DD");
  const yearSelected = dateNow.split("-")[0];
  const yearMenos90 = yearSelected - 100;
  let validateYearClient =
    parseInt(dateNow.split("-")[0]) - parseInt(date.split("-")[0]) >= 18 &&
    parseInt(dateNow.split("-")[0]) - parseInt(date.split("-")[0]) <= 100;

  let validatedateYear = parseInt(date.split("-")[0]) >= yearMenos90;

  let validateAgePresent =
    parseInt(dateNow.split("-")[0]) - parseInt(date.split("-")[0]) === 100;

  let validateAgePresentDps =
    parseInt(dateNow.split("-")[0]) - parseInt(date.split("-")[0]) >= 70;

  let validateDateOfAgeLimit =
    parseInt(dateNow.split("-")[1]) - parseInt(date.split("-")[1]) === 0 &&
    parseInt(dateNow.split("-")[2]) >= parseInt(date.split("-")[2]);

  if (!validatedateYear && value.length > 0)
    return "Ingrese un documento válido en el rango de 18 a 99 años";
  if (!validateYearClient && value.length > 0)
    return "Ingrese un documento válido  en el rango de 18 a 99 años";
  if (validateAgePresent && validateDateOfAgeLimit)
    return "Ingrese un fecha menor a los 100 años";
  if (validateAgePresentDps) setValue("dps", "true");
  //return "Ingrese un fecha menor a los 69 años";
};

export const validatorDate2 = (value, setValue, setDps) => {
  // if (value.length === 0) return "*Revisa los datos ingresados.";
  const edadContratante = calcularEdad(value);

  if (edadContratante <= 17) {
    return "Ingrese un documento válido en el rango de 18 a 99 años";
  }
  let date = value;
  if (!moment(date, "YYYY-MM-DD", true).isValid()) {
    if (moment(date, "DD/MM/YYYY", true).isValid()) {
      date = moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
    } else {
      return "Ingrese una fecha de nacimiento válida";
    }
  }

  let dateNow = moment().format("YYYY-MM-DD");
  const yearSelected = dateNow.split("-")[0];
  const yearMenos90 = yearSelected - 100;

  let validateYearClient =
    parseInt(dateNow.split("-")[0]) - parseInt(date.split("-")[0]) >= 18 &&
    parseInt(dateNow.split("-")[0]) - parseInt(date.split("-")[0]) <= 100;

  let validatedateYear = parseInt(date.split("-")[0]) >= yearMenos90;

  let validateAgePresent =
    parseInt(dateNow.split("-")[0]) - parseInt(date.split("-")[0]) === 100;

  let validateAgePresentDps =
    parseInt(dateNow.split("-")[0]) - parseInt(date.split("-")[0]) >= 70;

  let validateDateOfAgeLimit =
    parseInt(dateNow.split("-")[1]) - parseInt(date.split("-")[1]) === 0 &&
    parseInt(dateNow.split("-")[2]) >= parseInt(date.split("-")[2]);

  if (!validatedateYear && value.length > 0)
    return "Ingrese un documento válido en el rango de 18 a 99 años";
  if (!validateYearClient && value.length > 0)
    return "Ingrese un documento válido  en el rango de 18 a 99 años";
  if (validateAgePresent && validateDateOfAgeLimit)
    return "Ingrese un fecha menor a los 100 años";
  if (validateAgePresentDps) {
    setValue("dps", "true");
    setDps(true);
  }
  //return "Ingrese un fecha menor a los 69 años";
};

export const validatorFecha = (value, setValue) => {
  // if (value.length === 0) return "*Revisa los datos ingresados.";

  let date = value;
  if (!moment(date, "YYYY-MM-DD", true).isValid()) {
    if (moment(date, "DD/MM/YYYY", true).isValid()) {
      date = moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
    } else {
      return "Ingrese una fecha válida ##/##/####";
    }
  }
};

export const validateNumberDifferentZero = (value) => {
  if (value === 0){
    return "*El valor debe ser mayor a 0"
  }else {
    return true;
  }
};

export const getFilteredData = (rawData) => {
  const isEmpty = (value) => {
    return (
      value === "" ||
      value === null ||
      value === undefined ||
      (typeof value === "string" && value.trim() === "") ||
      (typeof value === "object" &&
        !Array.isArray(value) &&
        Object.keys(value).length === 0)
    );
  };

  const cleanObject = (obj) => {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      if (typeof value === "object" && value !== null && !Array.isArray(value)) {
        const nested = cleanObject(value);
        if (Object.keys(nested).length > 0) {
          acc[key] = nested;
        }
      } else if (!isEmpty(value)) {
        acc[key] = value;
      }
      return acc;
    }, {});
  };

  return cleanObject(rawData);
};

export const getFilteredDataKeepEmptyStrings = (rawData) => {
  const isEmpty = (value) => {
    return (
      value === null ||
      value === undefined ||
      (typeof value === "object" &&
        !Array.isArray(value) &&
        Object.keys(value).length === 0)
    );
  };

  const cleanObject = (obj) => {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      if (typeof value === "object" && value !== null && !Array.isArray(value)) {
        const nested = cleanObject(value);
        if (Object.keys(nested).length > 0) {
          acc[key] = nested;
        }
      } else if (!isEmpty(value)) {
        acc[key] = value;
      }
      return acc;
    }, {});
  };

  return cleanObject(rawData);
};

export const validateRangeDate = (initDate, endDate) => {
  const fechaProporcionada = new Date(initDate);
  const fechaActual = new Date(endDate);

  const diferencia = fechaProporcionada - fechaActual;
  const diferenciaEnDias = Math.round(diferencia / (1000 * 60 * 60 * 24));
  return diferenciaEnDias;
};

export const calcDaysPassed = (fechaString) => {
  const fechaProporcionada = new Date(fechaString);
  const fechaActual = new Date();

  const diferencia = fechaProporcionada - fechaActual;
  const diferenciaEnDias = Math.round(diferencia / (1000 * 60 * 60 * 24));
  return diferenciaEnDias;
};

export const calcMonthPassed = (fechaString) => {
  const a = moment();
  const b = moment(fechaString);
  const months = a.diff(b, 'months');
  const result = moment().add(2, 'months')[3, 4]
  return months;
};

export const validadorFechaMayor = (value) => {
  if (calcDaysPassed(value) >= 1) {
    return "La fecha no debe ser mayor al día de hoy";
  }

  if (typeof value !== "string") {
    return;
  }

  let date = value;

  // Verificar si la fecha es válida en alguno de los formatos
  if (!moment(date, ["YYYY-MM-DD", "DD/MM/YYYY"], true).isValid()) {
    return "Ingrese una fecha válida en el formato ##/##/#### o YYYY-MM-DD";
  }

  // Formatear la fecha al formato YYYY-MM-DD para una comparación consistente
  date = moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");

  // Obtener la fecha actual
  const fechaActual = moment().format("YYYY-MM-DD");

  // Comparar la fecha ingresada con la fecha actual
  if (moment(date).isAfter(fechaActual)) {
    return "La fecha no puede ser mayor que la fecha actual";
  }

  return true;
};

export const validatorFieldFirstName = (value) => {
  if (value == "") return "*Revisa los datos ingresados.";
};

export const validatorField = (value) => {
  if (value == "") return "*Revisa los datos ingresados.";
};

export const validatorRadios = (value) => {
  if (value == "") return "*Revisa los datos ingresados.";
};

export const comboValidator = (value) => {
  if (value == "") return "*Revisa los datos ingresados.";
};

export const validatorClientText = (value) => {
  let validateText = /^[A-Za-zÁÉÍÓÚáéíóúñÑ ]+$/g.test(value);
  if (!validateText) return "*Revisa los datos ingresados.";
};

export const validateAdress = (value) => {
  let validate = /^[A-Za-z0-9]+$/g.test(value);
  if (!validate) return "*Revisa los datos ingresados.";
};

export const validateDniAsesor = (value) => {
  let typeDoc = "2";
  let validateNumber = /[0-9]/.test(value);
  let validateLengthNumberDni =
    value.toString().length < 8 || value.toString().length >= 9;
  let validateLengthNumberCE = value.toString().length < 9;

  if (!validateNumber) return "Ingrese un documento correcto";

  if (validateLengthNumberDni && typeDoc == "2")
    return "Ingrese un documento correcto";
  if (validateLengthNumberCE && typeDoc == "1")
    return "Ingrese un documento correcto";

  if (value.length == "") return "*Revisa los datos ingresados.";
};

export const validatorFieldPrima = (values, getValues) => {
  let money_vas = getValues().money_vas;

  if (values == "") return "*Revisa los datos ingresados.";

  if (money_vas == "PEN" && parseFloat(values.split(",").join("")) < 15000)
    return "Prima Comercial: Prima debe ser mayor a S/15,000";

  if (money_vas == "USD" && parseFloat(values.split(",").join("")) < 5000)
    return "Prima Comercial: Prima debe ser mayor a $5,000";
};

export const validatorFieldPrimaAhorro = (values, money_vas) => {
  if (values == "") return "*Revisa los datos ingresados.";
  if (money_vas == "PEN" && parseFloat(values) < 15000)
    return "Prima Comercial: Prima debe ser mayor a S/15,000";
  if (money_vas == "USD" && parseFloat(values) < 5000)
    return "Prima Comercial: Prima debe ser mayor a $5,000";
};

export const validatorFieldPrimaRenta = (values, money_vas) => {
  if (values == "") return "*Revisa los datos ingresados.";
  if (money_vas == "PEN" && parseFloat(values) < 50000)
    return "Prima Comercial: Prima debe ser mayor a S/50,000";
  if (money_vas == "USD" && parseFloat(values) < 15000)
    return "Prima Comercial: Prima debe ser mayor a $15,000";
};

export const validatorFieldPrimaRentaRG = (values, money_vas) => {
  if (values == "") return "*Revisa los datos ingresados.";
  if (money_vas == "PEN" && parseFloat(values) < 50000)
    return "Prima Comercial: Prima debe ser mayor a S/50,000";
  if (money_vas == "PEN" && parseFloat(values) > 99999999999)
    return "Prima Comercial: Prima debe ser menor a S/999,999,999.99";
  if (money_vas == "USD" && parseFloat(values) < 15000)
    return "Prima Comercial: Prima debe ser mayor a $15,000";
  if (money_vas == "USD" && parseFloat(values) > 99999999999)
    return "Prima Comercial: Prima debe ser menor a $999,999,999.99";
};

export const validatorFieldPrimaInversion = (values) => {
  if (values == "") return "Campo requerido";
  if (parseFloat(values) < 15000) {
    return "Prima mínima comercial es de $15,000";
  }
};

export const validatorFieldPrimaUltraCash = (values, money_vas) => {
  if (values == "") return "*Revisa los datos ingresados.";
  if (money_vas == "PEN" && parseFloat(values) < 15000)
    return "Prima Comercial: Prima debe ser mayor a S/15,000";
  if (money_vas == "USD" && parseFloat(values) < 5000)
    return "Prima Comercial: Prima debe ser mayor a $5,000";
};

export const validatorFieldPrimaRi = (values, getValues) => {
  if (values == "") return "*Revisa los datos ingresados.";

  if (parseFloat(values.split(",").join("")) < 100000)
    return "Prima Comercial: Prima debe ser mayor a S/100,000";
};

export const validatorFieldPrimaIg = (values) => {
  if (values == "") return "*Revisa los datos ingresados.";

  if (parseFloat(values.split(",").join("")) < 30000) {
    return "Prima Comercial debe ser mayor a $ 30,000";
  }
};

//validateDniSimulations

export const validateDniSimulations = (value, typeDoc) => {
  let validateNumber = /[0-9]/.test(value);
  let validateLengthNumberDni = value.toString().length <= 8;
  let validateLengthNumberPassport = value.toString().length <= 15;
  let validateLengthNumberCE = value.toString().length <= 15;

  if (validateLengthNumberDni && typeDoc == "2")
    return "Ingrese un documento correcto";

  if (validateLengthNumberCE && typeDoc == "1")
    return "Ingrese un documento correcto";

  if (validateLengthNumberPassport && typeDoc == "3")
    return "Ingrese un documento correcto";

  if (value.length == "") return "*Revisa los datos ingresados.";
  if (!validateOnlyAlphanumeric(value))
    return "Sólo se permite letras y números.";
};

export const validateDni = (value, getValues) => {
  let typeDoc = getValues().typeDoc;

  let validateNumber = /[0-9]/.test(value);
  let validateLengthNumberDni = value.toString().length !== 8;
  let validateLengthNumberCE =
    value.toString().length < 9 || value.toString().length > 15;

  if (validateLengthNumberDni && typeDoc == "2")
    return "Ingrese un documento correcto";
  if (validateLengthNumberCE && typeDoc == "1")
    return "Ingrese un documento correcto";

  if (value.length == "") return "*Revisa los datos ingresados.";
  if (!validateOnlyAlphanumeric(value))
    return "Sólo se permite letras y números.";
};

export const validateDocumentByType = (documentNumber, getDocumentType) => {
  let documentType = getDocumentType().typeDoc; // this will show the document type
  const getDocumentSetting = getAllDocumentTypes.find(item => item.value == documentType);
  if (!getDocumentSetting) return "Tipo de documento no válido.";
  const { min, name } = getDocumentSetting;
  if (name === "PASAPORTE") {
    if (documentNumber.length < min || documentNumber.length > 10) {
      return "El número de documento es inválido.";
    }
  } else if (documentNumber.length !== min) {
    return "El número de documento es inválido.";
  }
}

export const validateDocumentRepLegalByType = (documentNumber, getDocumentType) => {
  let documentType = getDocumentType().typeDocReplegal; // this will show the document type
  const getDocumentSetting = getAllDocumentTypes.find(item => item.value == documentType);
  if (!getDocumentSetting) return "Tipo de documento no válido.";
  const { min, name } = getDocumentSetting;
  if (name === "PASAPORTE") {
    if (documentNumber.length < min || documentNumber.length > 10) {
      return "El número de documento es inválido.";
    }
  } else if (documentNumber.length !== min) {
    return "El número de documento es inválido.";
  }
}

export const validatorRate = (value) => {
  if (value === "") {
    return "*Revisa los datos ingresados.";
  }
  if (!/^(100|\d{1,2})(\.\d{1,2})?$/.test(value)) {
    return "Ingrese una tasa válida. Por ejm. 0.25";
  }
};

export const validatorRateNegative = (value) => {
  if (value === "") {
    return "*Revisa los datos ingresados.";
  }
  if (!/^(-)?(100|\d{1,2})(\.\d{1,2})?$/.test(value)) {
    return "Ingrese una tasa válida. Por ejm. 0.25";
  }
};

export const validateOnlyNumbers = (value) => {
  const re = /^[0-9\b]+$/;
  return re.test(value);
};

export const validateOnlyDecimalNumbers = (value) => {
  const re = /^\d*\.?\d*$/;
  return re.test(value);
}

export const validateOnlyAlphanumeric = (value) => {
  const re = /^[a-zA-Z0-9áéíóúÁÉÍÓÚäëïöüÄËÏÖÜñÑ\s.,-]*$/;
  return re.test(value);
};

export const validateTextOnlyAlphanumeric = (value) => {
  if (value === "") {
    return "*Revisa los datos ingresados.";
  }
  if (!validateOnlyAlphanumeric(value)) {
    return "Sólo se permite letras y números.";
  }
};

export const validateTextOnlyAlphanumericVia = (value) => {
  if (value === "") {
    return "*Revisa los datos ingresados.";
  }
  if (value.length < 3) {
    return "*Debe contener al menos 3 caracteres";
  }
  if (!validateOnlyAlphanumeric(value)) {
    return "Sólo se permite letras y números.";
  }
};

export const validateTextOnly = (value) => {
  if (value && !validateOnlyLetters(value)) {
    return "Sólo se permite letras.";
  }
};

export const validateOnlyLetters = (value) => {
  value = replaceAll(value, "-", " ");
  const accentedCharacters =
    "àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ,.'";
  const regex = "^[a-zA-Z" + accentedCharacters + " ]+$";
  const regexCompiled = new RegExp(regex);
  return regexCompiled.test(value);
};

export const replaceAll = (string, search, replace) => {
  return string.split(search).join(replace);
};

export const capitalize = (char) =>
  char.replace(/\b\w/g, (c) => c.toUpperCase());

export const validateHomePhone = (value) => {
  if (value === "") {
    return "*Revisa los datos ingresados.";
  }
  if (!validateOnlyNumbers(value)) {
    return "*El campo debe contener solo números";
  }
  if (value.length < 9) {
    return "*El número debe contener al menos 9 dígitos";
  }
};

export const OptionalvalidateHomePhone = (value) => {
  if (!validateOnlyNumbers(value)) {
    return "*El campo debe contener solo números";
  }
  if (value.length < 9) {
    return "*El número debe contener al menos 9 dígitos";
  }
};

export const validateRangeNumer = (value, init) => {
  if (value === "") {
    return "*Revisa los datos ingresados.";
  }
  if (value < init || value > 100) {
    return "*El número debe ser un rango de " + init + " a 100";
  }
};

export const validatePhoneVoid = (value) => {
  /*if (value === '') {
        return '*Revisa los datos ingresados.'
    }*/
  if (value.length > 0 && !validateOnlyNumbers(value)) {
    return "*Número de teléfono invalido";
  }
  if (value.length > 0 && value.length < 9) {
    return "*Número de teléfono incompleto";
  }
};

export const validateTin = (value) => {
  if (value.length > 0 && !/^[a-zA-Z0-9-]+$/.test(value)) {
    return "*El valor del TIN solo puede contener letras, números y guiones";
  }
};

export const validatePhone = (value) => {
  if (value === "") {
    return "*Número de celular invalido";
  }
  if (!validateOnlyNumbers(value)) {
    return "El campo debe contener solo números";
  }
  if (value.length < 6) {
    return "*Número de celular incompleto";
  }
};

export const validateEmail = (value) => {
  if (value === "") {
    return "*Revisa los datos ingresados.";
  }
  if (
    !/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(value)
  ) {
    return "*Correo invalido";
  }
};

export const validateRadioSepelio = (value, required) => {
  if (required && value === "") {
    return "*Campo Sepelio es requerido";
  }
};

export const validateSalary = (value) => {
  if (value === "") {
    return "*Campo Salario es requerido";
  }
};

export const validateRadio = (value) => {
  if (value === "") {
    return "*Campo sexo es requerido";
  }
};

export const validatePepRadio = (value) => {
  if (value === "") {
    return "*Campo PEP es requerido";
  }
}

export const validateNumberField = (value) => {
  if (value === "") {
    return "*Revisa los datos ingresados.";
  }
  if (!validateOnlyNumbers(value)) {
    return "El campo debe contener solo números";
  }
};

export const validateNumberYear = (value) => {
  if (value.length < 4) {
    return "*Revisa los datos ingresados.";
  }

  if (value === "") {
    return "*Revisa los datos ingresados.";
  }
  if (!validateOnlyNumbers(value)) {
    return "El campo debe contener solo números";
  }
};

export const validateValuesInQuote = ({ pdfValues, values }) => {
  if (pdfValues.length === 0) {
    return true;
  }

  if (pdfValues.length > 9) {
    return false;
  }

  return true;
};

const handleGetClient = (
  request,
  onDispatch,
  values,
  briefcase,
  userLogin,
  active,
  portafolio
) => {
  try {
    setTimeout(async () => {
      let dateNow = moment().format("YYYY-MM-DD");
      let dateVto = portafolio
        ? moment(dateNow).add("days", portafolio.diasVencimientoCotizacion)
        : undefined;
      let responses = await API.post("api-rentas", "/get-cotizacion", request);
      let resData = {
        ...values,
        ...responses,
        ...briefcase,
        userLogin,
        months: getMonths(),
        dateNow,
        dateVto,
        active,
      };
      onDispatch(resData, responses);
      return { error: false, resData };
    }, 5000);
  } catch (error) {
    return { error: true, resData: {} };
  }
};

export const callToAPIQuote = async ({
  request,
  active,
  onDispatch,
  values,
  userLogin,
  briefcase,
  portafolio,
}) => {
  try {
    let dateNow = moment().format("YYYY-MM-DD");
    let dateVto = portafolio
      ? moment(dateNow).add("days", portafolio.diasVencimientoCotizacion)
      : undefined;

    let response;
    response = await API.post("api-rentas", "/cotizacion", request);
    if (response.message && response.message.toLocaleUpperCase().includes(VALOR_OPORTUNIDAD)) {
      return { error: true, resData: {}, errorMessage: response.message };
    }
    if (response.status === "error") {
      // Aqui cae el error
      /* TODO: 
      // 1) Agregar 5 seg. para golpear la API /get-cotizacion
      */
      console.log("response", response);
      if (response.value) {
        toast.error(response.value, {
          position: toast.POSITION.TOP_CENTER,
          className: "toast-modal",
        });
      }
      handleGetClient(
        request,
        onDispatch,
        values,
        briefcase,
        userLogin,
        active,
        portafolio
      );
      // return { error: true, resData: {} };
    }

    values = values || {};
    briefcase = briefcase || {};

    let resData = {
      ...values,
      ...response,
      ...briefcase,
      userLogin,
      months: getMonths(),
      dateNow,
      dateVto,
      active: active,
    };
    onDispatch(resData, response);
    return { error: false, resData, errorMessage: "" };
  } catch (e) {
    // toast.error("Hubo problemas en el servidor..!!", {
    //   position: toast.POSITION.TOP_CENTER,
    //   className: "toast-modal",
    // });
    console.log("e", e);
    handleGetClient(
      request,
      onDispatch,
      values,
      briefcase,
      userLogin,
      active,
      portafolio
    );
    // return { error: true, resData: {} };
  }
};

export const validateMinValue = (value) => {
  const cleanedValue = value.replace(/[^0-9.-]+/g, "");
  let valueFormatted =  parseFloat(cleanedValue);
  if(valueFormatted > 30000){
    return true
  }else {
    return 'El valor mínimo debe ser 30.000'
  }
}

export const validatePlans = (value) => {
  if (value == "") return "*Debe seleccionar una opción válida.";
};
export const isUnderage = (date) => {
  if (!date) return false;
  const dateSplit = date.split("/");
  const dateFormated = `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`;
  const dateNow = new Date();
  const dateBeneficiary = new Date(dateFormated);
  const years = Math.abs(dateNow.getFullYear() - dateBeneficiary.getFullYear());
  return years < 18;
};

export const validateMobile = (value, getValues) => {
  if (value === "" && (getValues().mobile === "" || getValues().phone === ""))
    return "Ingrese un número válido";
  if (value === "") return true;
  if (value.length < 9)
    return "Número de celular incompleto";
  if (!/^[0-9\b]+$/.test(value))
    return "El campo debe contener solo números";
  return true;
}

export const validatePhoneNumber = (value) => {
  if (value === "") return "Ingrese un número válido";
  if(value.length < 9) {
    return "Número de teléfono incompleto";
  }
  if (!validateOnlyNumbers(value)) {
    return "El campo debe contener solo números";
  }
  return true;
};

export const validateNumberYear2 = (value) => {
  const currentYear = new Date().getFullYear();
  if (value === "" || value.length < 4) return "*Revisa los datos ingresados.";
  else if (!validateOnlyNumbers(value)) return "El campo debe contener solo números";
  else if (parseFloat(value) > currentYear) return "El valor ingresado no puede ser mayor al año actual";
  else if (parseFloat(value) < 1900) return "El valor ingresado no puede ser menor a 1900";
  return true;
};

export const validateNumberYear3 = (value) => {
  if (value === "") return "*Revisa los datos ingresados.";
  else if (!validateOnlyNumbers(value)) return "El campo debe contener solo números";
  return true;
};
